import { API } from 'aws-amplify';
import {
  REACT_APP_BASE_KEY,
  REACT_APP_BASE_NAME,
  REACT_APP_CLIENT_NAME,
} from '../config/settings/environments';

export const getHdopTrucks = async ({ year, month, day }) => {
  const paths = {
    talabre: '/v1/get-hdop-trucks',
  };
  let path = paths[REACT_APP_CLIENT_NAME] || '/v1/get-hdop-trucks';
  if (year && month && day) {
    path = `${path}?year=${year}&month=${month}&day=${day}`;
  }

  const response = await API.get(REACT_APP_BASE_NAME, path, {
    headers: { 'x-api-key': REACT_APP_BASE_KEY },
    response: true,
  });

  return {
    data: response.data,
    headers: response.headers,
    request: response.config,
    status: response.status,
  };
};

export const getFatigue = async ({ date, current_turn }) => {
  const paths = {
    talabre: '/v1/get-query-fatigue',
  };
  let path = paths[REACT_APP_CLIENT_NAME] || '/v1/get-query-fatigue';

  if (date && current_turn) {
    path = `${path}?date=${date}&current_turn=${current_turn}`;
  }

  const response = await API.get(REACT_APP_BASE_NAME, path, {
    headers: { 'x-api-key': REACT_APP_BASE_KEY },
    response: true,
  });

  return {
    data: response.data,
    headers: response.headers,
    request: response.config,
    status: response.status,
  };
};

export const getChecks = async ({ check_frentes, check_hdop, check_fatiga, check_conexion, check_vigencia_licencias, check_nuevas_licencias }) => {
  const paths = {
    talabre: '/v1/get-put-checks',
  };
  let path = paths[REACT_APP_CLIENT_NAME] || '/v1/get-put-checks';

  const params = {
    check_frentes,
    check_hdop,
    check_fatiga,
    check_conexion,
    check_vigencia_licencias,
    check_nuevas_licencias,
  };

  // Filtrar los parámetros con valores válidos
  const queryString = Object.entries(params)
    .filter(([key, value]) => value !== undefined && value !== null) // Ignorar valores no definidos o nulos
    .map(([key, value]) => `${key}=${value}`) // Convertirlos a formato clave=valor
    .join('&'); // Unirlos con &

  // Agregar la query string al path si hay parámetros
  if (queryString) {
    path = `${path}?${queryString}`;
  }

  const response = await API.get(REACT_APP_BASE_NAME, path, {
    headers: { 'x-api-key': REACT_APP_BASE_KEY },
    response: true,
  });

  return {
    data: response.data,
    headers: response.headers,
    request: response.config,
    status: response.status,
  };
};

export const getFrentes = async () => {
  const paths = {
    talabre: '/v1/get-frentes',
  };
  let path = paths[REACT_APP_CLIENT_NAME] || '/v1/get-frentes';

  const response = await API.get(REACT_APP_BASE_NAME, path, {
    headers: { 'x-api-key': REACT_APP_BASE_KEY },
    response: true,
  });

  return {
    data: response.data,
    headers: response.headers,
    request: response.config,
    status: response.status,
  };
};